__turbopack_context__.v({
  "canvas": "PixelField-module___rPtiW__canvas",
  "root": "PixelField-module___rPtiW__root",
});
